import config from "../config.json";
import http from "../Services/httpService";

function login(data) {
    //http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/kanon/Account/Login`, data);
}

function RequestVerifyCode(mobile, codeMeli) {
    //http.setJwt(http.getLocalJwt());
    //return http.get(`/WeatherForecast/get1`);
    return http.post(`${config.apiUrl}/api/kanon/Account/RequestVerifyCode?mobile=${mobile}&codeMeli=${codeMeli}`);
}



function SettingGet() {
    http.setJwt(http.getLocalJwt());
    return http.get(`${config.apiUrl}/api/kanon/Ozvesetting/Get`);
}

function OzveGet() {
    http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/kanon/WebOzve/Get`);
}

function RequestLoan() {
    http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/kanon/WebOzve/RequestLoan`);
}

function RequestTravel() {
    http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/kanon/WebOzve/RequestTravel`);
}

function Payment(mode) {
    http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/kanon/Payment/Payment?mode=${mode}`);
}
/*function Verify(id) {
    http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/kanon/Payment/Verify?id=${id}`);
}*/
function Verify(idGet,transId,factorId) {
    http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/kanon/Payment/Verify?factorId=${factorId}&trans_id=${transId}&id_get=${idGet}`);
}



function RequestInsuranceCancel() {
    http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/kanon/WebOzve/RequestInsuranceCancel`);
}
function RequestInsurance(data) {
    let form = new FormData();
    form.append('Shaba', data.shaba);
    form.append('Shobeh', data.shobeh);
    form.append('Form1', data.form1);
    form.append('Form2', data.form2);

    for (let i = 0; i < data.detail.length; i++) {
        form.append(`detail[${i}].name`, data.detail[i].name);
        form.append(`detail[${i}].family`, data.detail[i].family);
        form.append(`detail[${i}].fatherName`, data.detail[i].fatherName);
        form.append(`detail[${i}].code`, data.detail[i].code);
        form.append(`detail[${i}].codeMeli`, data.detail[i].codeMeli);
        form.append(`detail[${i}].placeBirthName`, data.detail[i].placeBirthName);
        form.append(`detail[${i}].birthDay`, data.detail[i].birthDay);
        form.append(`detail[${i}].nesbat`, data.detail[i].nesbat);
    }
    http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/kanon/WebOzve/RequestInsurance`, form);
}



function OzveRegister(data) {
    //http.setJwt(http.getLocalJwt());
    let form = new FormData();
    form.append('name', data.name);
    form.append('family', data.family);
    form.append('nameFather', data.nameFather);
    form.append('code', data.code);
    form.append('codeMeli', data.codeMeli);
    form.append('birthDay', data.birthDay);
    form.append('mostamariCode', data.mostamariCode);
    form.append('telfix', data.telfix);
    form.append('mobile', data.mobile);
    form.append('address', data.address);
    form.append('seriall', data.seriall);
    form.append('personeliPic', data.personeliPic);
    form.append('cardMeliPic', data.cardMeliPic);
    form.append('codePic', data.codePic);
    form.append('movafeghPic', data.movafeghPic);
    form.append('mostameriShobeh', data.mostameriShobeh);
    http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/kanon/WebOzve/post`, form);
}





export default {
    login, RequestVerifyCode
    , OzveGet, OzveRegister
    , SettingGet
    , RequestLoan
    , RequestTravel
    , RequestInsurance
    , Payment
    , Verify
    , RequestInsuranceCancel


};
